export const API_URL="https://api-v2.pakistanfoodportal.com"
// export const API_URL="https://pakistanfoodportal.com"
// export const API_URL="http://localhost:8000"